export const getDenominationFromUser = (user) => {
  if (!user.personRelations) return ''

  let firstName = user.personRelations[0]?.person.firstName ?? user.username
  let lastName = user.personRelations[0]?.person.lastName ?? ''

  return firstName + ' ' + lastName
}
